/**
 * Gift Customization Module
 * Handles delivery date restrictions, gift message toggles, character counters
 * and syncing the gift message to the cart note. The preferred delivery date
 * submits as its own cart attribute (attributes[Preferred delivery date]).
 */

(function() {
  'use strict';

  /**
   * 1. Delivery date restriction (2 business days minimum)
   */
  function initDeliveryDateRestriction() {
    const dateInput = document.getElementById('preferred-delivery-date');
    
    if (!dateInput) return;

    const today = new Date();
    let minDate = new Date(today);
    let businessDays = 0;

    while (businessDays < 2) {
      minDate.setDate(minDate.getDate() + 1);
      if (minDate.getDay() !== 0 && minDate.getDay() !== 6) {
        businessDays++;
      }
    }

    dateInput.min = minDate.toISOString().split('T')[0];
  }

  /**
   * 2. Toggle gift message visibility
   */
  function initGiftMessageToggle() {
    const toggleRadios = document.querySelectorAll('input[name="gift_note_toggle"]');
    const messageField = document.querySelector('.gift-field--conditional');

    if (!toggleRadios.length || !messageField) return;

    toggleRadios.forEach(radio => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;

        if (radio.value === 'yes') {
          messageField.classList.add('is-active');
          messageField.hidden = false;
        } else {
          messageField.classList.remove('is-active');
          messageField.hidden = true;
        }
      });
    });
  }

  /**
   * 3. Character counters for textareas
   */
  function initCharacterCounters() {
    document.querySelectorAll('textarea[maxlength]').forEach(textarea => {
      let counter = textarea.nextElementSibling;
      if (!counter || !(counter.classList && (counter.classList.contains('character-counter') || counter.classList.contains('char-count')))) {
        counter = textarea.parentElement && textarea.parentElement.querySelector('.character-counter, .char-count');
      }

      if (!counter) return;

      counter.textContent = `${textarea.value.length} / ${textarea.maxLength}`;

      textarea.addEventListener('input', () => {
        counter.textContent = `${textarea.value.length} / ${textarea.maxLength}`;
      });
    });
  }

  /**
   * 4. Sync gift message to cart note
   *    (Preferred delivery date now submits on its own as a real cart
   *    attribute via name="attributes[Preferred delivery date]" on the
   *    date input, so it no longer needs to be duplicated into the note.)
   */
  function syncToCartNote() {
    const noteField = document.getElementById('CartSpecialInstructions');
    if (!noteField) return;

    const message = document.getElementById('gift-message')?.value || '';
    const toggle = document.querySelector('input[name="gift_note_toggle"]:checked')?.value;

    let note = '';

    if (toggle === 'yes' && message) {
      note += `Gift Message: ${message}`;
    }

    noteField.value = note.trim();
  }

  /**
   * Initialize all gift customization features
   */
  function init() {
    initDeliveryDateRestriction();
    initGiftMessageToggle();
    initCharacterCounters();
    syncToCartNote();
  }

  // Sync on input/change
  document.addEventListener('input', syncToCartNote);
  document.addEventListener('change', syncToCartNote);

  // 🔑 Ensure sync right before form submit
  document.addEventListener('submit', syncToCartNote);

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section reload (for theme editor)
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('[data-gift-customization]')) {
      init();
    }
  });

})();